import type { IActivitiesEventState } from '../types';

export const initialState: IActivitiesEventState = {
  selectedFilters: {
    activitiesTypeFilters: [],
    distance: '1.0',
    eventModes: [],
    exerciseIntensities: [],
    recommendedAgeOption: '',
    timeOptions: [],
    startDate: undefined,
    endDate: undefined,
    keyword: '',
  },
  bookedActivityEvent: undefined,
  bookingError: undefined,
  filterOptions: undefined,
};
